// extracted by mini-css-extract-plugin
export default {"card":"ListCard_card__0KBJO","preview":"ListCard_preview__b4sO1","title":"ListCard_title__RNBOJ"};